<div class="row filter-type-selection-body">
  <div class="col-12">
    <div class="row filter-type-selection-header">
      <div class="col-12">Type</div>
    </div>
    <div class="row">
      <div class="col-6">
        <!-- <p-tree [value]="shareholderCharacteristics" [(selection)]="filter.shareholderCharacteristics" selectionMode="checkbox"></p-tree> -->
        <p-table
          [value]="shareholderCharacteristics"
          (click)="formDirty = true"
          [(selection)]="filter.shareholderCharacteristics"
          [scrollable]="true"
          (onRowSelect)="sortSelection(filter.shareholderCharacteristics)"
          dataKey="data"
        >
          <ng-template pTemplate="header">
            <tr>
              <th style="width: 3em" class="table-filter-row-header"><p-tableHeaderCheckbox></p-tableHeaderCheckbox>Select All</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData>
            <tr [pSelectableRow]="rowData" class="table-filter-row-data">
              <td><p-tableCheckbox [value]="rowData"></p-tableCheckbox>{{ rowData.label }}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
      <div class="col-6">
        <p-tree
          [value]="filter.shareholderCharacteristics"
          (click)="formDirty = true"
          [(selection)]="filter.shareholderCharacteristics"
          selectionMode="checkbox"
          emptyMessage=" "
          key="data"
        ></p-tree>
      </div>
    </div>
    <div class="row">
      <div class="col=12">
        <span class="help-block">
          <span *ngIf="formDirty && shareholderCharacteristicsField.invalid"> Please select an option </span>
        </span>
      </div>
    </div>
    <div class="row">
      <div class="col-4">
        <div class="form-group" [ngClass]="{ 'has-error': ShowValidationMessage(percentageOfOwnership) }">
          <span class="ey-float-label">
            <select
              class="form-control form-select"
              id="percentageOfOwnership"
              name="percentageOfOwnership"
              [(ngModel)]="filter.percentageOfOwnership"
              [disabled]="readOnly"
              #percentageOfOwnership="ngModel"
              appLabelFloat
            >
              <option *ngIf="!filter.percentageOfOwnership" [value]="undefined" disabled selected></option>
              <option value="0">At least one shareholder</option>
            </select>
            <label>From</label>
          </span>
          <span class="help-block">
            <span *ngIf="ShowValidationMessage(percentageOfOwnership)"> Please select a value </span>
          </span>
        </div>
      </div>
      <div class="col-4">
        <div class="form-group" [ngClass]="{ 'has-error': ShowValidationMessage(minimumPercent) }">
          <span class="ey-float-label">
            <input
              type="text"
              class="form-control"
              id="minimumPercent"
              name="minimumPercent"
              pattern="{{ regularExpressionPattern.NumberWithDecimalPattern }}"
              [(ngModel)]="filter.minimumPercent"
              [disabled]="readOnly"
              #minimumPercent="ngModel"
              maxlength="5"
              appLabelFloat
            />
            <label for="minimumPercent">Minimum %</label>
          </span>
          <span class="help-block" *ngIf="minimumPercent.errors?.pattern"> Enter a valid percentage </span>
        </div>
      </div>
      <div class="col-4">
        <div class="form-group" [ngClass]="{ 'has-error': ShowValidationMessage(maximumPercent) }">
          <span class="ey-float-label">
            <input
              type="text"
              class="form-control"
              id="maximumPercent"
              name="maximumPercent"
              pattern="{{ regularExpressionPattern.NumberWithDecimalPattern }}"
              [(ngModel)]="filter.maximumPercent"
              [disabled]="readOnly"
              #maximumPercent="ngModel"
              maxlength="5"
              appLabelFloat
            />
            <label for="maximumPercent">Maximum %</label>
          </span>
          <span class="help-block" *ngIf="maximumPercent.errors?.pattern"> Enter a valid percentage </span>
        </div>
      </div>
    </div>
  </div>
</div>
<fieldset ngModelGroup="shareholderCharacteristicsModGrp">
  <input
    type="hidden"
    [(ngModel)]="filter.shareholderCharacteristics"
    name="shareholderCharacteristicsField"
    #shareholderCharacteristicsField="ngModel"
    required
  />
</fieldset>
